{
  "settingsPresenter": {
    "title": "Einstellungen – {{fboName}}",
    "newHangarName": "Neuer Hangar",
    "buttons": {
      "addHangar": "Hangar anlegen"
    },
    "tabs": {
      "hangars": "Hangars",
      "ramps": "Vorfeld",
      "stackingSOPs": "Stapeln von SOPs",
      "towingEquipment": "Schleppen",
      "estimation": "Schätzung",
      "opsCenter": "Einsatzzentrale",
      "teamMembers": "Teammitglieder",
      "configuration": "Konfiguration",
      "reports": "Berichte",
      "integrations": "Integrationen",
      "account": "Konto"
    }
  },
  "rampsSettings": {
    "rampEditor": {
      "properties": "Properties",
      "rampVersion": "Ramp Version",
      "v2Algorithm": "V2 Algorithm",
      "toolbar": {
        "selectSpotSize": "Select spot size"
      }
    }
  }
}
